export default defineNuxtPlugin(async (nuxtApp) => {
  const { oneTrustId, enableUnbounce, enableOptimize, enableTracify } = nuxtApp.$config.public;
  const { locale } = nuxtApp.$i18n;

  const scripts = [];

  // check if we are in a Storybook environment
  const isStorybook =
    typeof window !== 'undefined' &&
    (window.__STORYBOOK_CLIENT_API__ || window.__STORYBOOK_ADDONS_CHANNEL__ || window.parent !== window);

  if (oneTrustId && !isStorybook) {
    try {
      const autoBlock = await fetch(`https://cdn.cookielaw.org/consent/${oneTrustId}/OtAutoBlock.js`);
      const autoBlockContent = await autoBlock.text();

      // inject script inline to save a request
      scripts.push({
        type: 'text/javascript',
        innerHTML: autoBlockContent,
      });
    } catch (e) {
      // if we could not fetch it, that might be because of the browser blocking. So lets add it as a script tag
      scripts.push({
        src: `https://cdn.cookielaw.org/consent/${oneTrustId}/OtAutoBlock.js`,
      });
    }

    scripts.push({
      type: 'text/javascript',
      src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
      'data-document-language': 'true',
      'data-domain-script': oneTrustId,
      defer: true,
    });

    scripts.push({ type: 'text/javascript', innerHTML: 'function OptanonWrapper() { }' });
  }

  if (enableUnbounce && !isStorybook) {
    scripts.push({
      src: 'https://5353afe5db084f38ad5d7caa9c85e3ce.js.ubembed.com',
      defer: true,
    });
  }

  if (enableOptimize && !isStorybook) {
    // ABlfyt Script
    scripts.push({
      type: 'text/javascript',
      src: 'https://cdn.ablyft.com/s/80692412.js',
    });
  }

  if (enableTracify && !isStorybook) {
    const tracifyIds = {
      de: '16684ff7-c87b-43d3-8fde-4a27478faa75',
      fr: '43eb1cdd-97fb-4187-9156-35b1d7053892',
      nl: 'f90ffc5d-fe3c-426b-bab6-153c3be07286',
      en: 'bc8834f4-8638-4302-bf29-966a528630cd',
      'ch-de': '5fbc5ec2-6c4f-4536-ac8d-47bdf8cc0789',
      'ch-fr': '5fbc5ec2-6c4f-4536-ac8d-47bdf8cc0789',
    };

    scripts.push({
      type: 'text/javascript',
      innerHTML: `
      var initTracify = function() {
        if (window.Tracify) {
          var tracify = window.Tracify({ csid: "${tracifyIds[locale.value]}"});
          tracify.capturePageView();
        }
      }`,
    });

    const tracifyScript = 'https://script.blackroll.com/api.v1.js';

    scripts.push({
      src: tracifyScript,
      async: true,
      onload: 'initTracify()',
    });
  }

  useHead({
    script: scripts,
  });
});
